<template>
  <GoogleMapLoader
    ref="mapLoader"
    :mapConfig="mapConfig"
    :apiKey="keyMap"
    :markers="markers"
    @ready="handleMapIsReady"
  >
    <template slot-scope="{ google, map }">
      <GoogleMapMarker
        v-for="marker in markers"
        :key="marker.id"
        :marker="marker"
        :google="google"
        :map="map"
        @click="handleMarkerClick"
        />
    </template>
  </GoogleMapLoader>
</template>

<script>
import GoogleMapLoader from "./mapLoader.vue";
import GoogleMapMarker from "./mapMarker.vue";
import { mapSettings } from "../js/mapSettings.js";

export default {
  name:"vqMap",
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
  },
  props: {
    keyMap: {
      type: String,
      required: false
    },
    markers:{ 
      type: Array,
      required:false
    }
  },
  data: () => ({
    infoWindow: null
  }),
  computed: {
    mapConfig() {
      return {
        ...mapSettings,
      };
    },
    mapCenter() {
      return this.markers[0].position;
    }
  },
  methods: {
    handleMapIsReady (map) {
      [...document.querySelectorAll('.js-trigger-marker')].map((el, i) => {
        el.addEventListener('click', (e) => {
          [...document.querySelectorAll('.js-trigger-marker')].forEach((el)=> {
            el.classList.remove('font-bold')
          });

          let id = e.target.dataset.id
          let goodMarker = this.markers.find(x => x.id == id);
          google.maps.event.trigger(goodMarker, 'click');
          document.body.scrollTop = 0
          document.documentElement.scrollTop = 0
          el.classList.add('font-bold')
        });
      });
      google.maps.event.addListener(map, 'click', (event) => {
        this.infoWindow.close()
      })
    },
    handleMarkerClick (event) {
      if (this.infoWindow) {
        this.infoWindow.close()
      }
      this.infoWindow = new google.maps.InfoWindow({
        content: event.content,
      })
      this.infoWindow.open({
        anchor: event.anchor,
        map: this.map,
      })
    }
  }
};
</script>
